<script setup lang="ts">
import DropdownItem from '@/Common/Elements/Dropdowns/DropdownItem.vue'
import { PhotoIcon } from '@heroicons/vue/20/solid'
import { usePromptInput } from './context'

interface Props {
  disabled?: boolean
  label?: string
}

const props = withDefaults(defineProps<Props>(), {
  label: 'Add photos or files',
})

const { openFileDialog } = usePromptInput()
</script>

<template>
  <DropdownItem
    :disabled="props.disabled"
    :icon="PhotoIcon"
    :label="props.label"
    @click="openFileDialog"
  />
</template>
